import React from "react";
//#region types
import { SurveyTodoFooterProps } from "models/propTypes/surveyPropsTypes";
import { ActionButton } from "models/propTypes/commonPropTypes";
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { PageFooter } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import useSurveySnoozeAction from "./actions/useSurveySnoozeAction";
import useSurveyForwardAction from "./actions/useSurveyForwardAction";
import { displayDialog } from "store/actions/utilActions";
import { useDispatch } from "react-redux";

const SurveyTodoFooter: React.FC<SurveyTodoFooterProps> = (props) => {
  const { id, markAsDoneHandler } = props;
  const dispatch = useDispatch();

  const { snoozeActionDialog } = useSurveySnoozeAction(id as string, markAsDoneHandler);
  const { forwardActionDialog } = useSurveyForwardAction(id as string, markAsDoneHandler);

  const onSnoozeClicked = async () => {
    dispatch(displayDialog(snoozeActionDialog));
  };

  const onForwardClicked = async () => {
    dispatch(displayDialog(forwardActionDialog));
  };

  const getActionButtons = (): ActionButton[] => {
    const buttons: ActionButton[] = [];

    buttons.push({
      text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Snooze),
      onClick: onSnoozeClicked,
      type: StyleEnums.DisplayType.Info,
    });

    buttons.push({
      text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Forward),
      onClick: onForwardClicked,
      type: StyleEnums.DisplayType.Info,
    });

    return buttons;
  };

  return <PageFooter actions={getActionButtons()} disableSuccessMessages />;
};

export default SurveyTodoFooter;
